(function () {
  'use strict';

  function LightboxController(modal) {
    this.modal = modal;
    this.scale = 1;
    this.tx = 0;
    this.ty = 0;
    this.dragging = false;
    this.dragStartX = 0;
    this.dragStartY = 0;
    this._pointerdownOnContent = false;
    this._patchHide();
    this._bind();
  }

  LightboxController.prototype._img = function () {
    return this.modal.querySelector('.product-media-modal__content img.active');
  };

  LightboxController.prototype._apply = function (img) {
    img.style.transform = 'translate(' + this.tx + 'px, ' + this.ty + 'px) scale(' + this.scale + ')';
  };

  LightboxController.prototype._clamp = function () {
    if (this.scale <= 1) { this.tx = 0; this.ty = 0; return; }
    var limit = (this.scale - 1) * 250;
    this.tx = Math.max(-limit, Math.min(limit, this.tx));
    this.ty = Math.max(-limit, Math.min(limit, this.ty));
  };

  LightboxController.prototype._reset = function () {
    this.scale = 1;
    this.tx = 0;
    this.ty = 0;
    this.dragging = false;
    var img = this._img();
    if (img) {
      img.style.transform = '';
      img.style.cursor = 'zoom-in';
    }
  };

  LightboxController.prototype._isOpen = function () {
    return this.modal.hasAttribute('open');
  };

  // Override hide() so clicking inside the image area never closes the modal
  LightboxController.prototype._patchHide = function () {
    var self = this;
    var modal = this.modal;
    var origHide = modal.hide.bind(modal);
    modal.hide = function () {
      if (self._pointerdownOnContent) {
        self._pointerdownOnContent = false;
        return;
      }
      origHide();
    };
  };

  LightboxController.prototype._bind = function () {
    var self = this;
    var modal = this.modal;

    // reset zoom when modal closes
    new MutationObserver(function () {
      if (!self._isOpen()) self._reset();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    // track whether the pointer went down inside the content area
    modal.addEventListener('pointerdown', function (e) {
      self._pointerdownOnContent = !!e.target.closest('.product-media-modal__content');
    }, true);

    // click to zoom in (step +1x, max 3x); at max resets
    modal.addEventListener('click', function (e) {
      if (!self._isOpen()) return;
      if (e.target.closest('.product-media-modal__toggle')) return;
      if (!e.target.closest('.product-media-modal__content')) return;
      var img = self._img();
      if (!img) return;
      e.stopPropagation();
      if (self.scale >= 3) { self._reset(); return; }
      self.scale = Math.min(self.scale + 1, 3);
      img.style.cursor = 'zoom-out';
      self._clamp();
      self._apply(img);
    });

    // double-click to reset
    modal.addEventListener('dblclick', function (e) {
      if (!self._isOpen()) return;
      if (e.target.closest('.product-media-modal__toggle')) return;
      self._reset();
    });

    // scroll wheel to zoom in/out
    modal.addEventListener('wheel', function (e) {
      if (!self._isOpen()) return;
      var img = self._img();
      if (!img) return;
      e.preventDefault();
      var delta = e.deltaY < 0 ? 0.25 : -0.25;
      self.scale = Math.max(1, Math.min(4, self.scale + delta));
      if (self.scale <= 1) { self._reset(); return; }
      img.style.cursor = 'zoom-out';
      self._clamp();
      self._apply(img);
    }, { passive: false });

    // drag to pan when zoomed
    modal.addEventListener('mousedown', function (e) {
      if (!self._isOpen() || self.scale <= 1) return;
      if (e.target.closest('.product-media-modal__toggle')) return;
      self.dragging = true;
      self.dragStartX = e.clientX - self.tx;
      self.dragStartY = e.clientY - self.ty;
      var img = self._img();
      if (img) img.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!self.dragging) return;
      self.tx = e.clientX - self.dragStartX;
      self.ty = e.clientY - self.dragStartY;
      self._clamp();
      var img = self._img();
      if (img) self._apply(img);
    });

    document.addEventListener('mouseup', function () {
      if (!self.dragging) return;
      self.dragging = false;
      var img = self._img();
      if (img && self.scale > 1) img.style.cursor = 'zoom-out';
    });
  };

  function init() {
    document.querySelectorAll('product-modal').forEach(function (el) {
      if (!el._hvacLightbox) el._hvacLightbox = new LightboxController(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
